import Vue from 'vue'

import langDe from 'quasar/lang/de'
import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import {
    Quasar,
    QAvatar,
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QInput,
    QCard,
    QCardSection,
    QCardActions,
    QImg,
    QScrollArea,
    QScrollObserver,
    QResizeObserver,
    QSeparator,
    QForm,
    QLinearProgress,
    QBadge,
    QCheckbox,
    QTooltip,
    QSelect,
    QFile,
    QField,
    QPopupProxy,
    QDate,
    QDialog,
    Loading
} from 'quasar'


Vue.use(Quasar, {
  config: {},
  lang: langDe,
  components: { QAvatar,
      QLayout,
      QHeader,
      QDrawer,
      QPageContainer,
      QPage,
      QToolbar,
      QToolbarTitle,
      QBtn,
      QIcon,
      QList,
      QItem,
      QItemSection,
      QItemLabel,
      QInput,
      QCard,
      QCardSection,
      QCardActions,
      QImg,
      QScrollArea,
      QScrollObserver,
      QResizeObserver,
      QSeparator,
      QForm,
      QLinearProgress,
      QBadge,
      QCheckbox,
      QTooltip,
      QSelect,
      QFile,
      QField,
      QPopupProxy,
      QDate,
      QDialog
  },
  directives: { /* not needed if importStrategy is not 'manual' */ },
  plugins: {
      Loading
  }
 })